import React, { useState, useEffect } from 'react';
import {Row,Button,Form, Col, Empty, DatePicker, notification, Space, Divider, List, Popconfirm} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {  faPlusCircle, faBoxCheck,  faBoxAlt } from '@fortawesome/pro-duotone-svg-icons';
import { Folha, Estoque } from '../../../componentes';
import moment from 'moment';
import {FormAddProdutoConferencia} from './form-add-produto-conferencia';
import {useAxios} from '../../../hooks';


const useConferencia = () => {

    // const [conferencia, setConferencia] = useState(null);

    // const start = () => {
    //     const conf = getLocal();
    //     setConferencia(conf);    
    // }

    const {getApiEmitirNotas} = useAxios();

    const getConferenciaLocal = () => {
        const confString = localStorage.getItem("conferencia");
        if(confString){
            const conferencia = JSON.parse(confString);
            conferencia.dataConferencia = moment(conferencia.dataConferencia)
            return conferencia

        }
        return null;
    }

    const salvaConferenciaLocal = conferencia => {
        if(conferencia === null)
            localStorage.removeItem('conferencia');
        else
            localStorage.setItem('conferencia', JSON.stringify(conferencia));
        
    }

    const processaConferencia = async conferencia => {
        const api = await getApiEmitirNotas();
        const {dataConferencia} = conferencia;
        const novaData = moment(dataConferencia).format("YYYY-MM-DD");
        conferencia.dataConferencia = novaData;
        const result = await api.post('/movimentacao-estoque/conferencia/', conferencia);
        
        return result.data;
    }

    

    // const iniciarConferencia = dataReferencia => {
    //     setConferencia({dataReferencia, itens: []});
    //     salvaLocal(conferencia);
    // }

    // const addItemConferencia = item => {
    //     conferencia.itens.push(item);
    //     salvaLocal();
    // }

    //start();

    return {salvaConferenciaLocal, getConferenciaLocal, processaConferencia};
}

const Conferencia = () => {
    
    const [conferencia, setConferencia] = useState(null);
    const {salvaConferenciaLocal, getConferenciaLocal, processaConferencia } = useConferencia();

    const [dataConferenciaConfirmada, setDataConferenciaConfirmada] = useState(false);

    const [formAddProdutoAberto, setFormAddProdutoAberto] = useState(false);
    const [loadingConferencia, setLoadingConferencia] = useState(false);
    
    

    const [form] = Form.useForm();


    useEffect(()=> {
        const conferencia = getConferenciaLocal();
        if(conferencia){
            setConferencia(conferencia);
            setDataConferenciaConfirmada(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const novaConferencia = () =>{

        setConferencia({ dataConferencia: moment() });
        
    }

    const abrirFormularioAddProduto = () => {
        setFormAddProdutoAberto(true);
    }

    const onCloseFormAddProdutoConferencia = () => {
        setFormAddProdutoAberto(false);
    }

    const confirmaData = () => {
        const dataConferencia = form.getFieldValue("dataConferencia");
        if(dataConferencia){
            const conferencia = { dataConferencia, itens: [] };
            setConferencia(conferencia);
            setDataConferenciaConfirmada(true);
            salvaConferenciaLocal(conferencia);
        }
    }

    const adicionarItemConferencia = item => {
        const c = conferencia;
        
        
        const filtroItem = c.itens.filter(i => item.produto.uuid === i.produto.uuid);
        const itemJaInserido = filtroItem.length;

        if(itemJaInserido > 0){
            const indiceItem = c.itens.indexOf(filtroItem[0]);
            c.itens.splice(indiceItem, 1);
        }

        c.itens.push(item);
        setConferencia(c);
        salvaConferenciaLocal(c);
        setFormAddProdutoAberto(false);
        
    }

    const removeItem = item => () => {
        const indice = conferencia.itens.indexOf(item);
        const conf = Object.assign({}, conferencia);
        conf.itens.splice(indice, 1);
        setConferencia(conf);
        salvaConferenciaLocal(conf);
    }

    const descartarConferencia = () => {
        const novaConferencia = null;
        setConferencia(novaConferencia);
        setDataConferenciaConfirmada(false);
        salvaConferenciaLocal(null);
        
    }

    const processaConferenciaHandleClick = async () => {
        setLoadingConferencia(true);
        try{
            const retorno = await processaConferencia(conferencia);
            if(retorno.sucesso){
                descartarConferencia();
            }
            notification.success({
                message: "Muito Bem!",
                description: "Conferencia de produtos processada com sucesso"

            })
        } catch(err){
            console.log(err);
            notification.error({
                message: "Ops!",
                description: "Não foi possivel processar a conferencia de produtos. Tente novamente"

            })
        }

        setLoadingConferencia(false);

    }


    const desenhaFormConferencia = () => {
        return (<><Form layout="vertical"  form={form} style={{textAlign: "left"}}>
            
            {(() => {

                if(!dataConferenciaConfirmada){
                    return (<>
                        <Space align="end" style={{marginBottom: "0"}}>
                        <Form.Item style={{marginBottom: "0"}} label="Data da conferência" name="dataConferencia" initialValue={conferencia.dataConferencia}>
                            <DatePicker format="DD/MM/YYYY"></DatePicker>
                        </Form.Item>
                        <Form.Item  style={{marginBottom: "0"}}>
                            <Button loading={loadingConferencia} type='primary' onClick={confirmaData}>Confirmar Data</Button>
                        </Form.Item>
                        </Space>
                    </>);
                }
                    
                return(<>
                    <Space align="center" style={{marginBottom: "0"}} >
                        <div>
                            Data de Conferencia: {conferencia.dataConferencia.format("DD/MM/YYYY")}
                        </div>
                        <Form.Item  style={{marginBottom: "0", float: "right"}}>
                            <Button type='primary' onClick={processaConferenciaHandleClick}>Processar Conferencia</Button>
                        </Form.Item>
                        
                        <Form.Item   style={{marginBottom: "0", float: "right"}}>
                            <Popconfirm
                                            title="Tem certeza disso?"
                                            okText="Sim"
                                            placement="bottom"
                                            cancelText="Não"
                                            onCancel={()=>{}}
                                            onConfirm={descartarConferencia}
                                        >
                                <Button disabled={loadingConferencia} type='link' style={{color: "red"}} >Descartar Tudo</Button>
                            </Popconfirm>
                        </Form.Item>
                        
                    </Space>
                    <Divider></Divider>
                    {(()=> {
                        if(conferencia.itens.length){
                            const itens = conferencia.itens.map(item => (

                                <List.Item key={item.produto.uuid}>
                                     <List.Item.Meta
                                        avatar={(() => {
                                            if(item.diferenca > 0){
                                                return (<FontAwesomeIcon size="3x"  fixedWidth={true} icon={faBoxAlt} style={{color: "green"}} />)
                                            } else if (item.diferenca < 0){
                                                return (<FontAwesomeIcon size="3x"  fixedWidth={true} icon={faBoxAlt} style={{color: "red"}} />)
                                            } 
                                            return (<FontAwesomeIcon size="3x" fixedWidth={true} icon={faBoxCheck} />)
                                        })()}
                                        title={(<>{item.produto.codigo} {item.produto.descricao}</>)}
                                        description={(<>
                                            <span style={{marginRight: '10px'}}>
                                                Em estoque:&nbsp;
                                                    <Estoque 
                                                        value={item.produto.saldoEstoque} 
                                                        unMedida={item.produto.uCom}
                                                    />
                                                </span>
                                            <span style={{marginRight: '10px'}}>
                                                Conferido:&nbsp;
                                                <Estoque 
                                                        value={item.quantidadeConferida}
                                                        unMedida={item.produto.uCom}
                                                />
                                            </span>
                                            <span style={{marginRight: '10px'}}>
                                                Corrigir em:&nbsp; 
                                                <Estoque 
                                                        value={item.diferenca}
                                                        unMedida={item.produto.uCom}
                                                /></span>
                                        </>)}
                                     />
                                    <div>
                                        <Popconfirm
                                            title="Tem certeza disso?"
                                            okText="Sim"
                                            cancelText="Não"
                                            onCancel={()=>{}}
                                            onConfirm={removeItem(item)}
                                        >
                                            <Button disabled={loadingConferencia} type="link" color="red">Remover</Button>
                                        </Popconfirm>
                                    </div>
                                    
                                </List.Item>));

                            return (<List>{itens}</List>)

                        }

                    })()}
                    <Row style={{marginTop: "23px", textAlign: "center"}}>
                        <Col span={24}>

                            <Form.Item>
                                <Button type="dashed" disabled={loadingConferencia} onClick={abrirFormularioAddProduto}>
                                    <FontAwesomeIcon
                                        icon={faPlusCircle}
                                    /> 
                                    Adicionar Conferência de um produto</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </>)

                    
                        

                        
            })()}




            

           
        </Form>
        
        <FormAddProdutoConferencia 
            visible={formAddProdutoAberto}
            onClose={onCloseFormAddProdutoConferencia}
            onFinish={adicionarItemConferencia}
            dataReferencia={conferencia.dataConferencia}
        ></FormAddProdutoConferencia>
</>);
    }

    const desenhaFolhaConferencia = () => {
        if(conferencia == null){
            return (<>
                <Row style={{padding: "23px 23px 0 23px"}}>
                    <Col>
                        <Button type="primary" onClick={novaConferencia}><FontAwesomeIcon icon={faPlusCircle} ></FontAwesomeIcon>Nova Conferencia</Button>
                    </Col>
                </Row>
                <Folha>
                    <Empty>Clique em <Button type="dashed" size="small" onClick={novaConferencia}><FontAwesomeIcon icon={faPlusCircle}></FontAwesomeIcon>Nova Conferencia</Button> para iniciar a checagem do estoque</Empty>
                </Folha>
            </>);
        }
        return (
            <Folha>
                {desenhaFormConferencia()}
            </Folha>
        );
    }

    return (<>
    
    
    {desenhaFolhaConferencia()}
   

    
    </>);
}

export {Conferencia}